module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("f3K1U"))).then(() => parcelRequire('dJXJK'));